module.exports = __webpack_public_path__ + "static/logo_blue-969f307ebd4f007507d21cc389a32a98.jpg";